<template>
  <v-app>
    <v-card width="400" class="mx-auto pt-10 pb-10" style="margin-top:180px;">
      <div class="pb-3"><h2 class="text-center">ログイン</h2></div>
      <v-card-text>
        <v-form
           ref="form"
           v-model="valid"
        >
          <v-text-field
            label="ID"
            v-model="username"
            prepend-inner-icon="mdi-account-circle"
            outlined
            @keyup.enter="login()"
            :rules="[v => !!v || 'メールアドレスを入力してください.']"
          />
          <v-text-field
            label="パスワード"
            type="password"
            v-model="password"
            prepend-inner-icon="mdi-lock"
            outlined
            @keyup.enter="login()"
            :rules="[v => !!v || 'パスワードを入力してください.']"
          />
        </v-form>
          <v-row justify="space-between" class="pt-6">
          <v-col cols="12">
          <v-btn width="100%" color="light-green darken-1" class="white--text" @click="login()">
              ログイン
          </v-btn>
          </v-col>
          <v-col cols="12" v-if="is_err" class="err_msg">
              {{ err_msg }}
          </v-col>
          </v-row>
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import myMixin from '@/mixin.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
/* eslint-disable */


export default {
   mixins: [myMixin],
   data() {  // datas
      return{
          connection: null,
          valid: false,
          is_err: true,
          err_msg: '',
          username: '',
          password: '',
          items: [
              { name: 'Name 1', optionSelected:  'Option 2' },
              { name: 'Name 2', optionSelected: null },
              { name: 'Name 3', optionSelected: null },
            ],
          options: ['Option 1', 'Option 2', 'Option 3'],
          from_path: 'reservecalendar',
      } // datas
   },
   methods: {
        async login() {
            console.log('login()');
            console.log('username: ', this.username);
            console.log('password: ', this.password);

            // 期限を延長するためにクリアさせる.
            localStorage.clear('user');

            this.err_msg = '';
            this.valid = this.$refs.form.validate()
            console.log('valid: ', this.valid);
            if(!this.valid){
                return false;
            }

            let token = await this.getToken();  // ここのawaitがないと即座に下記が実行される.
            console.log('待つよ getToken()');
            console.log(token);

            if(token.status==='NG'){
                this.err_msg = token.msg;
                return false;
            }



            if(token.status==='OK'){
                // 認証が通ったら、localStorageに保存.
                // token: と user: をシリアライズして格納する
                delete token.status;
                delete token.token_type;
                delete token.msg;
                localStorage.setItem( 'user', JSON.stringify(token) );

                this.$store.dispatch( 'user', token.user );
                this.getNotice();

                // リダイレクト
                this.$router.push({name:this.from_path}).catch(()=>{});

            }

        },  //login()


        // 下記のように最低限必要なリクエストを送れば、tokenを取得できる.
        // 呼び出し側で await getToken() で呼び出せば、responseがあるまで停止する
        async getToken(){
            console.log('getToken()');

            const formData = new FormData();
            formData.append('username', this.username);
            formData.append('password', this.password);

            return axios.post('/token', formData)
                .then( response => {
                    return response.data;
                });
        },

    },  // methods


    async created () {
        console.log('%c created: LoginView.vue', mycolor.created);
        console.log('route: ', this.$route);
        if(this.$route.query.from && this.$route.query.from!=='' && this.$route.query.from!='login'){
            this.from_path = this.$route.query.from;
        }
        console.log('from_path', this.from_path);
    },
    mounted () {
    },
    computed:{
        ...mapGetters(['user', 'user_name', 'is_admin']),
    }
}
</script>
<style scoped>
/deep/ .v-text-field--enclosed .v-input__prepend-inner {
    margin: 0;
    margin: auto;
}
/deep/ .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
    height: 54px;
}
/deep/ .v-btn:not(.v-btn--round).v-size--default{
    height: 44px;
}
</style>
